import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import type { LeadStage } from "../api/leads";
import { stageColor, tint } from "../pages/leadPipeline";

/**
 * Coloured lead stage pill: kind-derived colour
 * (ACTIVE blue ramp / WON green / LOST red) with a translucent fill and the
 * localized stage label. Colour is never the only signal — the label always
 * shows the phase name. Mirrors the offers stage-pill idiom.
 */
export function LeadStageBadge({ stage }: { stage: LeadStage }) {
  const { t } = useTranslation();
  const color = stageColor(stage);
  const style: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "3px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    color: "var(--ink)",
    background: tint(color),
    border: `1px solid ${color}`,
    whiteSpace: "nowrap",
  };
  return (
    <span style={style}>
      <span aria-hidden style={{ width: 8, height: 8, borderRadius: "50%", background: color, flex: "none" }} />
      {t(`leads.stage.${stage}`, stage)}
    </span>
  );
}
